import React from 'react';
import { string, shape, arrayOf } from 'prop-types';
import classNames from 'classnames';
import CreditOfferList from '../../credit-offer-list';
import ActionRow from '../../action-row';
import { trackEvent } from '../../../lib/tracking';

const namespace = 'ui-vip-body-proposal';
const DEFAULT_BODY = {};

const BodyProposal = ({ body = DEFAULT_BODY }) => {
  const { credit_options, action } = body;

  return (
    <div className={classNames(`${namespace}__container`)}>
      {credit_options && <CreditOfferList options={credit_options.options} />}
      {action && (
        <ActionRow
          className={`${namespace}__action-row`}
          label={action.label.text}
          modifier="secondary"
          url={action.target}
          onClick={() => trackEvent(action.track)}
        />
      )}
    </div>
  );
};

BodyProposal.propTypes = {
  body: shape({
    credit_options: arrayOf(
      shape({
        title: string.isRequired,
        subtitle: string.isRequired,
        value: string.isRequired,
      }),
    ),
    action: shape({
      label: shape({
        text: string.isRequired,
      }).isRequired,
      target: string,
    }).isRequired,
  }),
};

export default BodyProposal;
